<template>
  <Autocomplete
    :initial-input-text="inputText"
    :initial-selected-item="evaluators.find(e => e.id === initialEvaluatorId)"
    :results="filteredEvaluators"
    :limit="evaluators.length"
    @select="onSelect"
    @update="onUpdate"
    @blur="onBlur"
  />
  <input type="hidden" :name="`evaluator_ids[${stage}]`" v-model="selectedEvaluatorId">
  <div class="text text-danger" v-if="hasError">
    入力された名前の評価者は存在しません。
  </div>
</template>

<script>
import Autocomplete from "../../Autocomplete.vue";
import {computed, ref, watch} from "vue";

export default {
  name: "FormEvaluators",
  props: {
    evaluators: {
      type: Object,
      required: true,
    },
    stage: {
      type: Number,
      required: true,
    },
    initialEvaluatorId: {
      type: Number,
      required: false,
    }
  },
  emits: ['select'],
  components: {
    Autocomplete,
  },
  setup(props, { emit }) {
    const selectedEvaluatorId = ref(props.initialEvaluatorId);
    const inputText = ref(props.evaluators.find(e => e.id === selectedEvaluatorId.value)?.name ?? '');

    watch(() => props.initialEvaluatorId, (newVal) => {
      selectedEvaluatorId.value = newVal;
      inputText.value = props.evaluators.find(e => e.id === selectedEvaluatorId.value)?.name ?? '';
    });

    const onSelect = (input, selectedItem) => {
      selectedEvaluatorId.value = selectedItem?.id;
      emit('select', selectedEvaluatorId.value);
    }

    const onUpdate = (input) => {
      inputText.value = input;
      selectedEvaluatorId.value = props.evaluators.find(e => e.name === input)?.id
    }

    /**
     * 入力された文字列で評価者候補を絞り込む
     */
    const filteredEvaluators = computed(() => {
      if (inputText.value === '') {
        return props.evaluators;
      }
      return props.evaluators.filter(evaluator => {
        return evaluator.name.indexOf(inputText.value) > -1;
      })
    });

    /**
     * 入力された評価者名のユーザーが存在するどうか判定し、
     * 不正なものだった場合エラーメッセージを表示する
     */
    const hasError = ref(false);
    /**
     * Blur時の処理
     * 入力された評価者名のバリデーションを更新する
     */
    const onBlur = () => {
      hasError.value = inputText.value && !selectedEvaluatorId.value;
    };

    return {
      selectedEvaluatorId,
      onSelect,
      onUpdate,
      filteredEvaluators,
      inputText,
      hasError,
      onBlur,
    }
  }
}
</script>

<style scoped>

</style>
